import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import Upload from '@/api/mjegb/Upload';
import Resource from '@/api/Resource';
import ApiWrapper from '@/api/ApiWrapper';
import networkBoundResource from '@/api/networkBoundResource';
import unwrapApiWrapper from '@/api/unwrapApiWrapper';

export default class FileRepository {
    private readonly client: HttpClient;
    private readonly baseUrl: string;

    public constructor(client: HttpClient, apiEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint + '/file';
    }

    public getFile(id: number): Observable<Resource<Upload>> {
        const observable = this.client.get<ApiWrapper<Upload>>('' + id, { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public getFileUrl(id: number): string {
        return this.baseUrl + '/' + id + '/download';
    }

    public uploadFile(file: File): Observable<Resource<Upload>> {
        const formData = new FormData();
        formData.append('file', file);
        const observable = this.client.post<ApiWrapper<Upload>>('upload', formData, { baseUrl: this.baseUrl });
        return networkBoundResource(unwrapApiWrapper(observable));
    }
}
